import React from "react";
import {
  Box,
  Grid,
  Typography,
  Link,
  Container,
  IconButton,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { getFooter } from "../../api/footer";

import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import { useLanguage } from "../../context/LanguageContext";


/* ================= THEME ================= */
const THEME_COLOR = "#ffffff";

function Footer() {
  const { language } = useLanguage();
  const [footer, setFooter] = useState(null);
  useEffect(() => {
    fetchFooter();
  }, [language]);

  const fetchFooter = async () => {

    try {

      const data = await getFooter(language);

      console.log("footer__", data);

      setFooter(data);

    } catch (err) {

      console.error(err);

    }
  };

  return (
    <Box sx={{ backgroundColor: "#0f172a", color: "#ffffff", py: 5 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* ================= ABOUT ================= */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                borderBottom: `2px solid ${THEME_COLOR}`,
                display: "inline-block",
              }}
            >
              {language === "mr" ? "पत्ता" : "Address"}
            </Typography>

            <Typography variant="body2" sx={{ mb: 1 }}>
              {footer?.addressTitle}
              {/* {language === "mr"
                ? "शहर आपत्ती व्यवस्थापन आराखडा २०२६"
                : "City Disaster Management Plan 2026"} */}
            </Typography>

            {/* Contact Details */}
            <Typography
              variant="body2"
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 1,
                mb: 0.5,
              }}
            >
              <LocationOnIcon sx={{ fontSize: 16, mt: "2px" }} />

              <span>
                <strong>
                  {language === "mr" ? "पत्ता:" : "Address:"}
                </strong>{" "}
                <Box>
                  {footer?.address?.map((item, index) => (
                    <Typography
                      key={index}
                      variant="body2"
                      sx={{
                        color: "#fff",
                        lineHeight: 1.6,
                      }}
                    >
                      {item?.children?.[0]?.text}
                    </Typography>
                  ))}
                </Box>
                {/* {language === "mr"
                  ? `छत्रपती शिवाजी महाराज प्रशासकीय इमारत,नागपूर महानगरपालिका,महानगर पालिका मार्ग, सिव्हिल लाईन्स,नागपूर, महाराष्ट्र,भारत, ४४० ००१`
                  : `Chhatrapati Shivaji Maharaj Administrative Building,Nagpur Municipal Corporation,Mahanagar Palika Marg, Civil Lines,Nagpur, Maharashtra,India, 440001`} */}
                {/* {language === "mr"
                  ? "५३३७+एमजे९, लेडीज क्लब लॉन समोर, सेमिनरी हिल्स, नागपूर, महाराष्ट्र ४४०००१"
                  : "5337+MJ9, Opposite Ladies Club Lawn, Seminary Hills, Nagpur, Maharashtra 440001"} */}
              </span>
            </Typography>

            <Typography
              variant="body2"
              sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}
            >
              <EmailIcon sx={{ fontSize: 16 }} />
              {/* cfo@nmc.gov.in */}
              <a
                href={footer?.emailLink}
                style={{
                  color: "#fff",
                  textDecoration: "none",
                }}
              >
                {footer?.email}
              </a>
            </Typography>

            <Typography
              variant="body2"
              sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}
            >
              <PhoneIcon sx={{ fontSize: 16 }} />
              {/* 0253 – 2571872 /2317505 */}
              <a
                href={footer?.phoneLink}
                style={{
                  color: "#fff",
                  textDecoration: "none",
                }}
              >
                {footer?.phone}
              </a>
            </Typography>

            {/* Social Media */}
            <Box sx={{ display: "flex", gap: 2, mt: 2 }}>

              <IconButton
                component="a"
                href={footer?.facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  backgroundColor: "rgba(255,255,255,0.12)",
                  color: "#fff",
                }}
              >
                <FacebookIcon />
              </IconButton>

              <IconButton
                component="a"
                href={footer?.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  backgroundColor: "rgba(255,255,255,0.12)",
                  color: "#fff",
                }}
              >
                <InstagramIcon />
              </IconButton>

              <IconButton
                component="a"
                href={footer?.youtubeUrl}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  backgroundColor: "rgba(255,255,255,0.12)",
                  color: "#fff",
                }}
              >
                <YouTubeIcon />
              </IconButton>

            </Box>
            {/* <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
              {[
                {
                  icon: FacebookIcon,
                  link: "https://www.facebook.com/DIOfficeNagpur/",
                  label: "Facebook",
                },
                {
                  icon: InstagramIcon,
                  link: "https://www.instagram.com/dionagpur/",
                  label: "Instagram",
                },
                {
                  icon: YouTubeIcon,
                  link: "https://www.youtube.com/@NagpurMunicipalCorporation",
                  label: "YouTube",
                },
              ].map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <IconButton
                    key={index}
                    component="a"
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={item.label}
                    sx={{
                      backgroundColor: "rgba(255,255,255,0.12)",
                      color: "#fff",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        backgroundColor: "rgba(255,255,255,0.25)",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <IconComponent />
                  </IconButton>
                );
              })}
            </Box> */}
          </Grid>

          {/* ================= QUICK LINKS ================= */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                borderBottom: `2px solid ${THEME_COLOR}`,
                display: "inline-block",
              }}
            >
              {language === "mr" ? "त्वरित दुवे" : "Quick Links"}
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              {/* <Link
                component={RouterLink}
                to="/"
                underline="hover"
                sx={{ color: "#fff", "&:hover": { color: THEME_COLOR } }}
              >
                {language === "mr" ? "मुख्यपृष्ठ" : "Home"}
              </Link> */}

              {/* <Link
                component={RouterLink}
                to="/overview"
                underline="hover"
                sx={{ color: "#fff", "&:hover": { color: THEME_COLOR } }}
              >
                {language === "mr"
                  ? "आमच्याबद्दल"
                  : "About us"}
              </Link> */}

              <Link
                component={RouterLink}
                to="/cdmp/documents"
                underline="hover"
                sx={{ color: "#fff", "&:hover": { color: THEME_COLOR } }}
              >
                {language === "mr" ? "सीडीएमपी दस्तऐवज" : "CDMP Document"}
              </Link>

              {/* <Link
                component={RouterLink}
                to="/cdmp/hazard-profile"
                underline="hover"
                sx={{ color: "#fff", "&:hover": { color: THEME_COLOR } }}
              >
                {language === "mr"
                  ? "धोका प्रोफाइल"
                  : "Hazard Profile"}
              </Link>

              <Link
                component={RouterLink}
                to="/cdmp/reconstruction-and-rehabilitation"
                underline="hover"
                sx={{ color: "#fff", "&:hover": { color: THEME_COLOR } }}
              >
                {language === "mr" ? "पुनर्रचना आणि पुनर्वसन" : "Reconstruction And Rehabilitation"}
              </Link> */}
            </Box>
          </Grid>

          {/* ================= RESOURCES ================= */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                borderBottom: `2px solid ${THEME_COLOR}`,
                display: "inline-block",
              }}
            >
              {language === "mr" ? "महत्वाच्या लिंक्स" : "Important Links"}
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              {/* NIDM */}
              <Link
                href="https://nidm.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: "#fff", "&:hover": { color: THEME_COLOR } }}
              >
                {language === "mr"
                  ? "NIDM"
                  : "NIDM"}
              </Link>

              {/* NMC */}
              <Link
                href="https://www.nmcnagpur.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: "#fff", "&:hover": { color: THEME_COLOR } }}
              >
                {language === "mr"
                  ? "NMC"
                  : "NMC"}
              </Link>

              {/* NDMA */}
              <Link
                href="https://ndma.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: "#fff", "&:hover": { color: THEME_COLOR } }}
              >
                {language === "mr"
                  ? "मानक कार्यपद्धती व तपासणी यादी"
                  : "NDMA"}
              </Link>

              {/* UNDRR */}
              <Link
                href="https://www.undrr.org/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: "#fff", "&:hover": { color: THEME_COLOR } }}
              >
                {language === "mr" ? "भागीदार दुवे" : "UNDRR"}
              </Link>

              {/* SFDR */}
              {/* <Link
                href="https://finance.ec.europa.eu/regulation-and-supervision/financial-services-legislation/implementing-and-delegated-acts/sustainable-finance-disclosures-regulation_en"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: "#fff", "&:hover": { color: THEME_COLOR } }}
              >
                {language === "mr" ? "भागीदार दुवे" : "SFDR"}
              </Link> */}

              {/* SDG */}
              {/* <Link
                href="https://www.undrr.org/disaster-risk-and-2030-agenda-sustainable-development"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: "#fff", "&:hover": { color: THEME_COLOR } }}
              >
                {language === "mr" ? "भागीदार दुवे" : "SDG"}
              </Link> */}
            </Box>
          </Grid>


          {/* ================= CONTACT & MAP ================= */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                borderBottom: `2px solid ${THEME_COLOR}`,
                display: "inline-block",
              }}
            >
              {language === "mr" ? "संपर्क" : "Contact Us"}
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
              <Link
                component={RouterLink}
                to="/cdmp/contact-information"
                underline="hover"
                sx={{ color: "#fff", "&:hover": { color: THEME_COLOR } }}
              >
                {language === "mr" ? "संपर्क माहिती" : "Contact Information"}
              </Link>

              {/* <Link
                component={RouterLink}
                to="/grievance/track"
                underline="hover"
                sx={{ color: "#fff", "&:hover": { color: THEME_COLOR } }}
              >
                {language === "mr" ? "तक्रार स्थिती तपासा" : "Track Grievance"}
              </Link> */}

              <Link
                component={RouterLink}
                to="/grievance/submit"
                underline="hover"
                sx={{
                  color: "#fff",
                  "&:hover": { color: THEME_COLOR },
                }}
              >
                {language === "mr" ? "अभिप्राय व तक्रारी" : "Feedback and Grievances"}
              </Link>
              <Link
                component={RouterLink}
                to="/privacy-policy"
                underline="hover"
                sx={{
                  color: "#fff",
                  "&:hover": { color: THEME_COLOR },
                }}
              >
                {language === "mr" ? "गोपनीयता धोरण" : "Privacy Policy"}
              </Link>
              <Link
                component={RouterLink}
                to="/terms-conditions"
                underline="hover"
                sx={{
                  color: "#fff",
                  "&:hover": { color: THEME_COLOR },
                }}
              >
                {language === "mr" ? "नियम आणि अटी" : "Terms and Conditions"}
              </Link>
            </Box>

            {/* Map */}
            <Box sx={{ borderRadius: 1, overflow: "hidden" }}>
              <iframe
                title="Office Location Map"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d59534.59460898306!2d79.0297954!3d21.1558936!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4c11dec716715%3A0xf8ab0d392b84eaff!2sNagpur%20Municipal%20Corporation!5e0!3m2!1sen!2sin!4v1776924348837!5m2!1sen!2sin"
                width="100%"
                height="150"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </Box>
          </Grid>
        </Grid>

      </Container>
      {/* ================= COPYRIGHT ================= */}
      <Box
        sx={{
          mt: 5,
          borderTop: "1px solid rgba(255,255,255,0.2)",
          width: "100%",
          Height: 20, // controls vertical space
          display: "flex",
          alignItems: "center", // 🔥 vertical center
          justifyContent: "center", // horizontal center
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="body2"
            align="center"
            sx={{
              textAlign: "center",
              alignItems: "center",
              width: "100%",
              paddingTop: "2rem",
              lineHeight: 1.5,
            }}
          >
            {footer?.copyright}
            {/* {language === "mr"
              ? "© २०२६ शहर आपत्ती व्यवस्थापन विभाग. सर्व हक्क राखीव."
              : "© 2026 City Disaster Management Department. All rights reserved."} */}
          </Typography>
          <Typography
            variant="body2"
            align="center"
            sx={{
              textAlign: "center",
              alignItems: "center",
              width: "100%",
              paddingTop: "0.3rem",
              lineHeight: 1.5,
              color: "#ff9800"
            }}
          >
            {footer?.disclaimer}
            {/* {language === "mr"
              ? "ही एक डेमो सिस्टम आहे. दाखवलेला सर्व डेटा फक्त सादरीकरणासाठी आहे."
              : "This is a demo system. All data shown is for presentation purposes only."} */}
          </Typography>
        </Container>
      </Box>


    </Box>
  );
}

export default Footer;
